import { motion } from "framer-motion";
import { ShieldCheck, Sparkles, Smile, Smartphone, RefreshCw } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "Safe learning time", color: "bg-green-100 text-green-700 border-green-300" },
  { icon: Sparkles, title: "Fun + educational", color: "bg-purple-100 text-purple-700 border-purple-300" },
  { icon: Smile, title: "Easy for kids", color: "bg-amber-100 text-amber-700 border-amber-300" },
  { icon: Smartphone, title: "Works on mobile", color: "bg-cyan-100 text-cyan-700 border-cyan-300" },
  { icon: RefreshCw, title: "New content regularly", color: "bg-rose-100 text-rose-700 border-rose-300" },
];

const ParentTrust = () => {
  return (
    <section className="py-10 bg-cyan-50">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-2xl md:text-4xl font-fredoka font-bold text-center text-gray-800 mb-6"
        >
          Why Parents Love TinyMinds 💛
        </motion.h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4 max-w-5xl mx-auto">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                whileHover={{ scale: 1.05, y: -4 }}
                className={`${it.color} border-2 rounded-2xl p-4 flex flex-col items-center text-center shadow-md`}
              >
                <Icon className="w-8 h-8 md:w-10 md:h-10 mb-2" />
                <p className="font-fredoka font-bold text-sm md:text-base leading-tight">
                  {it.title}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ParentTrust;
